import React from "react";
import { LucideIcon } from "lucide-react";
import { PulseLoader } from "react-spinners";

type OverviewCardProps = {
  title: string;
  value: string | number;
  icon?: LucideIcon;
  iconBg: string;
  isLoading?: boolean;
  loadingColor?: string;
  change?: string;
  isPositive?: boolean;
  className?: string; // ⬅️ ADDED
};

const OverviewCard: React.FC<OverviewCardProps> = ({
  title,
  value,
  icon: Icon,
  change,
  isPositive,
  iconBg,
  loadingColor,
  isLoading,
  className = "", // ⬅️ ADDED
}) => {
  return (
    <div
      className={`bg-white p-4 sm:p-3 rounded-lg border border-borderColor w-full ${className}`}
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <div className="flex flex-1 gap-3 items-start sm:items-center">
          {/* Icon */}
          {Icon && (
            <div
              className={`flex items-center justify-center h-8 w-8 sm:h-10 sm:w-10 rounded-full ${iconBg}`}
            >
              <Icon className="text-white w-4 h-4 sm:w-5 sm:h-5" />
            </div>
          )}

          {/* Title and Value */}
          <div className="flex flex-col">
            <span className="text-xs sm:text-sm text-gray-500">{title}</span>
            <p className="text-xl sm:text-2xl font-bold mt-1">
              {isLoading ? (
                <PulseLoader color={loadingColor} size={8} />
              ) : (
                value
              )}
            </p>
          </div>
        </div>

        {/* Change Info */}
        {change && (
          <div className="flex flex-col items-end text-right">
            <p
              className={`text-xs sm:text-sm font-medium ${
                isPositive ? "text-green-500" : "text-red-500"
              }`}
            >
              {change}
            </p>
            <div className="text-[10px] sm:text-[11px] text-gray-400">
              Increase this month
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OverviewCard;
